export default __webpack_public_path__ + "static/prompt-latin-600-normal-254d93074de60e71061897a92be0f6e2.woff2";